export const getClassDisplayName = (schoolClass, fallback = "Turma não informada") => {
  const value = schoolClass?.displayName ?? schoolClass?.classDisplayName;
  return typeof value === "string" && value.trim() ? value : fallback;
};

export const getClassInstitutionName = (schoolClass) =>
  schoolClass?.institution?.name || schoolClass?.institutionName || "Instituição não informada";

export const getClassOptionLabel = (schoolClass) =>
  `${getClassDisplayName(schoolClass)} — ${getClassInstitutionName(schoolClass)}`;
